import clsx from "clsx";

export const CustomLoader = ({ className }) => {
  return (
    <div
      className={clsx(
        "w-full h-[170px] animate-pulse bg-gray-300 rounded-[10px]",
        className
      )}
    ></div>
  );
};
